import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { withDownloadToast } from "../withDownloadToast";
import { WORKSHEET_NAME } from "./constants";
import { populateWorksheet } from "./worksheet";
import { clearFileName } from "../exportTableToExcel";

/**
 * Exports a DOM table (by id) to an .xlsx file with cell styles and auto column width.
 */
export default async function exportWithStyles(
  tableId,
  fileName = "InsightOut Data",
  page,
  dateFilters,
  menuFilters,
  domain
) {
  const table = document
    .getElementById(tableId)
    ?.querySelector("table")
    ?.cloneNode(true);

  if (!table) return;

  const workbook = new ExcelJS.Workbook();

  const title = fileName ? clearFileName(fileName) : WORKSHEET_NAME;

  const worksheet = workbook.addWorksheet(title);

  populateWorksheet(
    table,
    worksheet,
    page,
    dateFilters,
    menuFilters,
    fileName,
    domain
  );

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const filename = `${fileName}.xlsx`;

  await withDownloadToast(filename, () => saveAs(blob, filename));
}
